<div class="center user-image-wrapper">
  <img [src]="getPhotoUrl(user?.photo)" [alt]="user?.getShortName()" class="user-image" />
  <div *ngIf="showName" [innerHTML]="user?.getShortName()" class="w-hidden-small w-hidden-tiny"></div>
</div>
